import { useMediaQuery, useTheme } from '@material-ui/core'
import { Link, useLocation, useHistory } from 'react-router-dom'
import './Navbar.css'
import DrawerComponent from './mobileNavDrawyer/Drawer'
import { useAuth } from '../auth/Auth'
import { GpLogo } from '../components/gp'

const headerStyle = {
    background: 'var(--gp-card)',
    borderBottom: '1px solid var(--gp-hairline)',
    padding: '14px 40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 1100,
}

const mobileHeaderStyle = {
    ...headerStyle,
    padding: '12px 20px',
}

const activeItemStyle = {
    font: 'var(--gp-body-med)',
    padding: '9px 18px',
    borderRadius: 999,
    background: 'var(--gp-brand)',
    color: '#FFFFFF',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    border: 'none',
    textDecoration: 'none',
}

const itemStyle = {
    font: 'var(--gp-body)',
    padding: '9px 18px',
    color: 'var(--gp-ink)',
    background: 'transparent',
    border: 'none',
    textDecoration: 'none',
    opacity: 0.85,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
}

const getInitials = (user) => {
    const a = user?.attributes || {}
    const full =
        a.name ||
        [a.given_name, a.family_name].filter(Boolean).join(' ') ||
        a.email ||
        user?.username ||
        ''
    const parts = full.trim().split(/[\s@.]+/).filter(Boolean)
    if (parts.length === 0) return '?'
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return (parts[0][0] + parts[1][0]).toUpperCase()
}

const AUTH_ROUTES = ['/sign-in', '/sign-up', '/forgot-password']

function Navbar(props) {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const location = useLocation()
    const history = useHistory()
    const { pathname } = location
    const splitLocation = pathname.split('/')
    const auth = useAuth()

    // Auth screens (Login / SignUp / ResetPassword) own their own chrome
    // via GpAuthShell — hide the top bar so we don't get two logos.
    if (AUTH_ROUTES.some((p) => pathname === p || pathname.startsWith(p + '/'))) {
        return null
    }

    const handleLogoClick = () => {
        history.push('/dashboard')
    }

    const goToDashboard = () => {
        history.push('/dashboard')
    }

    const goToMyAccount = () => {
        history.push('/my-account')
    }

    const isDashboardActive =
        splitLocation[1] === 'dashboard' ||
        splitLocation[1] === 'installer-dashboard'
    const isMyAccountActive = splitLocation[1] === 'my-account'
    const isLoginActive = splitLocation[1] === 'sign-in'

    if (isMobile) {
        return (
            <header style={mobileHeaderStyle}>
                <span
                    style={{ cursor: 'pointer', display: 'inline-flex' }}
                    onClick={handleLogoClick}
                >
                    <GpLogo size={18} />
                </span>
                <DrawerComponent logout={props.logout} />
            </header>
        )
    }

    return (
        <header style={headerStyle}>
            <span
                style={{ cursor: 'pointer', display: 'inline-flex' }}
                onClick={handleLogoClick}
            >
                <GpLogo size={22} />
            </span>
            <nav
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    whiteSpace: 'nowrap',
                }}
            >
                {!auth.user && (
                    <Link
                        to="/sign-in"
                        style={isLoginActive ? activeItemStyle : itemStyle}
                    >
                        {location.pathname.startsWith('/joinProperty')
                            ? 'Login if you already have an account'
                            : 'Login'}
                    </Link>
                )}
                {auth.user && (
                    <span
                        onClick={goToDashboard}
                        style={isDashboardActive ? activeItemStyle : itemStyle}
                    >
                        Dashboard
                    </span>
                )}
                {auth.user && !auth.isInstaller && (
                    <span
                        onClick={goToMyAccount}
                        style={isMyAccountActive ? activeItemStyle : itemStyle}
                    >
                        My Account
                    </span>
                )}
                {auth.user && (
                    <span
                        data-testid="cypress-navbar-logout"
                        onClick={props.logout}
                        style={itemStyle}
                    >
                        Sign Out
                    </span>
                )}
                {auth.user && (
                    <div
                        style={{
                            marginLeft: 14,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            paddingLeft: 16,
                            borderLeft: '1px solid var(--gp-hairline)',
                        }}
                    >
                        <div
                            aria-label="Account"
                            style={{
                                width: 34,
                                height: 34,
                                borderRadius: '50%',
                                background: 'var(--gp-surface)',
                                border: '1px solid var(--gp-hairline)',
                                color: 'var(--gp-brand)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                font: '500 13px/1 var(--gp-font)',
                                letterSpacing: 0.3,
                            }}
                        >
                            {getInitials(auth.user)}
                        </div>
                    </div>
                )}
            </nav>
        </header>
    )
}
export default Navbar
